module.exports = __webpack_public_path__ + "vrplayerstatic/media/fullScreenOff.c2b14e3a.svg";